/* Système de tri catalogue */
const $catalogFilters = $('.results-list__filters .filters__filter-title');
if($catalogFilters.length) {
    $catalogFilters.on('click', function(e) {
        e.preventDefault();
        
        $(this).toggleClass('opened');
        const $filterContent = $(this).next('.filters__filter-content');
        
        if($filterContent.length) {
            $filterContent.toggle();
        }
    });
}